import _assign from "object-assign";

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import deepmerge from 'deepmerge';

var createDefaultOverlayable = function createDefaultOverlayable(zIndex) {
  return {
    // ordered by level based on MUI defaults
    mobileStepper: {
      zIndex: zIndex.mobileStepper
    },
    appBar: {
      zIndex: zIndex.appBar
    },
    drawer: {
      zIndex: zIndex.drawer
    },
    modal: {
      zIndex: zIndex.modal
    },
    snackbar: {
      zIndex: zIndex.snackbar
    },
    tooltip: {
      zIndex: zIndex.tooltip
    }
  };
};

var createGetOverlayable = function createGetOverlayable(options) {
  return function (variant) {
    return options[variant];
  };
};

export var createOverlayable = function createOverlayable(zIndex) {
  var overlayable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var _ref = typeof overlayable === 'function' ? overlayable(zIndex) : overlayable,
      otherGetOverlayable = _ref.getOverlayable,
      otherOptions = _objectWithoutProperties(_ref, ["getOverlayable"]);

  var defaultOverlayable = createDefaultOverlayable(zIndex);
  var mergedOptions = deepmerge(defaultOverlayable, otherOptions, {
    clone: false
  });
  return _assign({
    getOverlayable: otherGetOverlayable || createGetOverlayable(mergedOptions)
  }, mergedOptions);
};